<template>
  <div
    class="bg-white-1 border-beige-10 shadow-card relative flex flex-col gap-2 rounded-lg border border-solid p-5"
  >
    <slot></slot>
  </div>
</template>
